import { AxiosPromise } from 'axios';
import axios from 'axios';
import { IFinishOceanReq, IGetOceanUrl } from '../models/oceanTest.model';

const uri = '/service/ocean-test';

export const getOceanUrl = (oceanTestCode: number): AxiosPromise<IGetOceanUrl> => {
  return axios.get(`${uri}/start/${oceanTestCode}`);
}

export const getOceanResultUrl = (oceanTestCode: number): AxiosPromise<IGetOceanUrl> => {
  return axios.get(`${uri}/report/${oceanTestCode}`);
}

export const finishOcean = (oceanTestCode: number, data: IFinishOceanReq): AxiosPromise => {
  return axios.put(`${uri}/end/${oceanTestCode}`, data);
}

export const getPredigerHistoryCode = (oceanTestCode: number): AxiosPromise<number> => {
  return axios.get(`/prediger/report/${oceanTestCode}`);
}
